<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-4 col-md-4">
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
      </div>
      <!-- <div class="col-lg-6 col-md-6 mg-a" style="text-align: right;" >
      <span class="slctDteLbl">Select Date:</span>
      <nz-date-picker [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat" [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)" class="dte_picker"></nz-date-picker>


    </div> -->
      <div class="col-lg-4 col-md-4 mg-a">
        <span class="slctDteLbl">Select District:</span>

        <nz-select
          class="slctBx"
          style="width: 200px; text-align: left"
          nzShowSearch
          [(ngModel)]="slctd_dstrt"
          (ngModelChange)="getDstrwiseData($event)"
          [ngModelOptions]="{ standalone: true }"
          nzPlaceHolder="Select a district"
        >
          @for (v of dstrtdata; track v) {
          <nz-option [nzValue]="v.tnt_id" [nzLabel]="v.tnt_nm"></nz-option>
          }
        </nz-select>
      </div>
      <!-- <div class="col-lg-4 col-md-4 mg-a" style="text-align: right;">
    <span class="stdsbrdBtn" (click)="gotoDstrctDshbrd()"> Go to State Dashboard</span>
  </div> -->
      <div class="col-lg-4 col-md-4 mg-a" style="text-align: right">
        <button
          nz-button
          nz-tooltip
          nzTooltipTitle="Go to State Dashboard"
          (click)="gotoDstrctDshbrd()"
          class="back-btn"
        >
          <!-- <nz-icon nzType="arrow-left" nzTheme="outline"></nz-icon> -->
          <span nz-icon nzType="arrow-left" nzTheme="outline"></span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="apsfl_dshbrd">
  <app-oms-dashbourd-cards
    [slctd_dstrt]="slctd_dstrt"
    [slctCrd]="slctdCrd"
    (slctdata)="selctedCatrd($event)"
  ></app-oms-dashbourd-cards>

  <div class="row">
    <div class="col-md-12">
      <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
        <!-- <div class="row" style="margin-top:-10px;margin-bottom:5px">
        <div class="col-md-8">
          <div class="card_hdr_ttl" *ngIf="slctdCrd?.crd_hdr == 'WORKS'" style="position: relative;">
          Activities</div>
          <div class="card_hdr_ttl" *ngIf="slctdCrd?.crd_hdr == 'TRIPS'" style="position: relative;">
            Travel Registry
          </div>
          <div class="card_hdr_ttl" *ngIf="slctdCrd?.crd_hdr == 'EXPENSES'" style="position: relative;">
          Expenses</div>
        </div> -->
        <div class="card_ttl">
          <div class="row">
            <div class="col-md-8">
              @if (tb_nm == 'WORKS') {
              <div class="card_hdr_ttl" style="position: relative">
                Activities
              </div>
              } @if (tb_nm == 'TRIPS') {
              <div class="card_hdr_ttl" style="position: relative">
                Travel Registry
              </div>
              } @if (tb_nm == 'EXPENSES') {
              <div class="card_hdr_ttl" style="position: relative">
                Expenses
              </div>
              }
            </div>
            <div class="col-md-10">
              <div class="row pstnCls">
                <div
                  class="col-md-12"
                  style="text-align: left; padding-left: 20px"
                >
                  @if (lvl_id!=3) {
                  <nz-range-picker
                    [(ngModel)]="dateRnge"
                    [nzFormat]="'dd-MM-yyyy'"
                    (ngModelChange)="onChangeDate()"
                  ></nz-range-picker>
                  }
                </div>
              </div>
            </div>
            <div class="col-md-2"></div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 mgnb-2 p-8">
          <app-data-grid
            [totalItems]="gridTotals0"
            [groupItems]="gridGroups0"
            id="gridContainer"
            class="p-8"
            style="width: 100%"
            [dataSource]="gridData"
            [legacyColumns]="columnDefs"
            keyExpr="sno"
            [searchPanel]="true"
            [filterRow]="true"
            [filterPanel]="true"
            [groupPanel]="false"
            [columnChooser]="false"
            [allowExport]="true"
            [pageSize]="10"
            [allowedPageSizes]="[5, 10, 25, 50]"
            [showPageSizeSelector]="true"
            [showBorders]="true"
            (cellClick)="onCellClick($event)"
            [cellPrepared]="bound_onCellPrepared"
          >
            <!-- -->
            <!-- -->
            <!--
            <app-grid-column [showInColumnChooser]="false" [visible]="true" type="buttons" [width]="100" caption="View"
            cellTemplate="editTemplate"></app-grid-column>
            <ng-template appGridCell="editTemplate" let-data="cell"><div>
              <div class="tblEdtBtn" (click)="gotoWorkProfile(data)">
                <i nz-icon nzType="node-index" nzTheme="outline"></i>
                <p>View Profile</p>
              </div>
            </div></ng-template>
            -->

            <app-grid-column
              [visible]="tb_id != '3'"
              [showInColumnChooser]="false"
              type="buttons"
              [width]="100"
              caption="View"
              cellTemplate="editTemplate"
            ></app-grid-column>
            <ng-template appGridCell="editTemplate" let-data="cell"
              ><div>
                @if (data.rowType=='data') {
                <div>
                  @if (tb_id=='1') {
                  <div class="tblEdtBtn" (click)="gotoProfile(data, 'work')">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                    <p>View Profile</p>
                  </div>
                  } @if (tb_id=='2') {
                  <div class="tblEdtBtn" (click)="gotoTripTimeline(data)">
                    <i nz-icon nzType="eye" nzTheme="outline"></i>
                    <p>Trip Timeline</p>
                  </div>
                  }
                </div>
                }
              </div></ng-template
            >
            <!--
            <app-grid-column [visible]="tb_id=='2'" [showInColumnChooser]="false"   type="buttons" [width]="100"
            caption="View" cellTemplate="editTemplate"></app-grid-column>
            <ng-template appGridCell="editTemplate" let-data="cell"><div>

              <div class="tblEdtBtn" *ngIf="data.rowType=='data'" (click)="gotoTripTimeline(data)">{{tb_id}}ff
                <i nz-icon nzType="eye" nzTheme="outline"></i>
                <p>Trip Timeline</p>
              </div>
            </div></ng-template>
            -->
          </app-data-grid>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="crd_style">
        <div class="card_ttl">
          <div class="row">
            <!-- <div class="col-md-10">
            <div class="row pstnCls" style="position: relative;">
              <div class="col-md-12">
                <div class="card_hdr_ttl" style="position: relative;left:0px">Activities</div>

              </div>
            </div>
          </div> -->
            <div class="col-lg-12 col-md-12">
              <div
                class="row"
                style="
                  padding: 10px;
                  margin-bottom: 0px;
                  background: linear-gradient(45deg, #fff4e7, #ffeded);
                  border-radius: 10px 10px 0px 0px;
                "
              >
                <div class="col-lg-2 col-md-2">
                  <div class="fltrLbls">Work Group</div>
                  <nz-select
                    nzShowSearch
                    class="slctBx"
                    [(ngModel)]="wrk_grp_id"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                    @for (t of wrkGrpLst; track t) {
                    <nz-option
                      [nzValue]="t.wrk_grp_id"
                      [nzLabel]="t.wrk_grp_nm"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </div>
                <div class="col-lg-2 col-md-2">
                  <div class="fltrLbls">Work Status</div>
                  <nz-select
                    nzShowSearch
                    class="slctBx"
                    [(ngModel)]="oms_wrk_sts_id"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <nz-option [nzLabel]="'All'" [nzValue]="0"></nz-option>
                    @for (t of wrkStsLst; track t) {
                    <nz-option
                      [nzValue]="t.oms_wrk_sts_id"
                      [nzLabel]="t.wrk_sts_nm"
                    >
                    </nz-option>
                    }
                  </nz-select>
                </div>
                <div class="col-lg-3 col-md-3">
                  <!-- <div class="fltrLbls">From</div>
                <nz-date-picker [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat"
                  [(ngModel)]="frmDt" (ngModelChange)="onChange($event)"
                style="    width: 100%; height: 32px; "></nz-date-picker>
              </div>
              <div class="col-lg-2 col-md-2">
                <div class="fltrLbls">To</div>
                <nz-date-picker [nzDisabledDate]="disabledDate" [nzFormat]="dateFormat"
                  [(ngModel)]="toDt" (ngModelChange)="onDtChange($event)"
                style="    width: 100%; height: 32px; "></nz-date-picker> -->
                  <div class="fltrLbls">Select Date</div>
                  <nz-range-picker
                    [(ngModel)]="dateRange"
                    (ngModelChange)="onChange($event)"
                    [nzFormat]="'dd-MM-yyyy'"
                    style="height: 37px; border-radius: 4px"
                  ></nz-range-picker>
                </div>
                <div class="col-lg-2 col-md-2">
                  <button
                    (click)="getInPrgrsWrks()"
                    style="
                      margin-top: 24px;
                      background: #f15a22;
                      color: #fff;
                      border: currentColor;
                      border-radius: 4px;
                      border: 2px solid #ffb49f;
                      cursor: pointer;
                    "
                  >
                    Get Data
                  </button>
                </div>
              </div>
            </div>
            <div id="dstdbrdMap"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (tb_id=='1') {
  <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
    <div class="col-lg-12 col-md-12 mgnb-2 p-8">
      <div class="card_ttl">
        <div class="row">
          <div class="col-md-8">
            <div class="card_hdr_ttl" style="position: relative">Employees</div>
          </div>
        </div>
      </div>
      <app-data-grid
        id="gridContainer"
        class="p-8"
        style="width: 100%"
        [dataSource]="EmployData"
        [legacyColumns]="columnEmplyDefs"
        keyExpr="sno"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="false"
        [allowExport]="true"
        [pageSize]="10"
        [allowedPageSizes]="[5, 10, 25, 50]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="false"
        [showBorders]="true"
      >
        <!-- -->
        <!-- -->
        <!-- -->
        @if (tb_id=='1') {
        <app-grid-column
          [showInColumnChooser]="false"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        }
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoProfile(data, 'employ')">
              <i nz-icon nzType="eye" nzTheme="outline"></i>
              <p>View Profile</p>
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  } @if (tb_id=='2') {
  <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
    <div class="col-lg-12 col-md-12 mgnb-2 p-8">
      <div class="card_ttl">
        <div class="row">
          <div class="col-md-8">
            <div class="card_hdr_ttl" style="position: relative">Vehicles</div>
          </div>
        </div>
      </div>
      <app-data-grid
        id="gridContainer"
        class="p-8"
        style="width: 100%"
        [dataSource]="vehicleData"
        [legacyColumns]="columnVhcleDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="false"
        [allowExport]="true"
        [pageSize]="10"
        [allowedPageSizes]="[5, 10, 25, 50]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <!-- -->
        <!-- -->
        <!-- -->
        @if (tb_id=='2') {
        <app-grid-column
          [showInColumnChooser]="false"
          type="buttons"
          [width]="100"
          caption="View"
          cellTemplate="editTemplate"
        ></app-grid-column>
        }
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div class="tblEdtBtn" (click)="gotoProfile(data, 'Vehicles')">
              <i nz-icon nzType="node-index" nzTheme="outline"></i>
              <p>View Profile</p>
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  }

  <nz-drawer
    [nzBodyStyle]="{ overflow: 'auto' }"
    [nzMaskClosable]="false"
    [nzWidth]="dwrWdth"
    [nzVisible]="sidenav"
    [nzTitle]="drwerTitle"
    (nzOnClose)="closeSideBar()"
    nzWrapClassName="wrkPrfleDrawer"
  >
    <ng-container *nzDrawerContent>
      @if (appCond==1) {
      <div>
        <app-wrok-profile [wrkData]="wrkData"></app-wrok-profile>
      </div>
      } @if (appCond==2) {
      <div class="apsfl_dshbrd">
        <app-emplye-prfle [wrkData]="wrkData"></app-emplye-prfle>
      </div>
      } @if (appCond==3) {
      <div class="apsfl_dshbrd">
        <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
      </div>
      } @if (appCond==4) {
      <div class="apsfl_dshbrd">
        <app-trip-timeline [tripId]="slctd_trp"></app-trip-timeline>
      </div>
      }
    </ng-container>
  </nz-drawer>
</div>
